import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';
import { ChatContextValue } from './chat-context.slice';

export type Flow = {
  chatId: string;
  type: 'no-flow' | 'no-scope' | 'no-collections';
  suggestedQueries: SuggestedQuery[];
};

export type SuggestedQuery = {
  query: string;
  context: ChatContextValue;
};

const initialFlowState: {
  flows: Flow[];
} = {
  flows: [],
};

export const flowsSliceName = 'flows';

export const flowsSlice = createSlice({
  name: flowsSliceName,
  initialState: initialFlowState,
  reducers: {
    addSuggestedQuery: (state, action) => {
      // find the flow by chatId and update the suggestedQueries
      const currentFlow = state.flows.find((flow) => flow.chatId === action.payload.chatId);
      // check if the same query already exists in the currentFlow's suggestedQueries
      if (currentFlow && !currentFlow.suggestedQueries.some((existingQuery) => existingQuery.query === action.payload.query.query)) {
        currentFlow.suggestedQueries.push(action.payload.query);
      }
    },

    clearSuggestedQueries: (state, action) => {
      const currentFlow = state.flows.find((flow) => flow.chatId === action.payload.chatId);
      if (currentFlow) {
        currentFlow.suggestedQueries = [];
      }
    },

    initializeChatFlow: (state, action) => {
      // create a new individual Flow and add it to flows[]
      const newFlow = {
        chatId: action.payload.chatId,
        type: action.payload.type,
        suggestedQueries: action.payload.suggestedQueries,
      };
      state.flows.push(newFlow);
    },
    updateFlowType: (state, action) => {
      // find the flow by chatId and update the type
      const currentFlow = state.flows.find((flow) => flow.chatId === action.payload.chatId);
      if (currentFlow) {
        currentFlow.type = action.payload.type;
      }
    },
    deleteFlow: (state, action) => {
      // delete the flow by chatId
      state.flows = state.flows.filter((flow) => flow.chatId !== action.payload.chatId);
    },
  },
});

export default flowsSlice.reducer;
export const { addSuggestedQuery, clearSuggestedQueries, initializeChatFlow, updateFlowType, deleteFlow } = flowsSlice.actions;
export const selectAllFlows = (state: RootState) => state[flowsSliceName].flows;
